import _omit from "lodash/omit";

export const BANDEIRAS_CARTAO = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  elo: 'Elo',
  amex: 'American Express',
  hipercard: 'Hipercard',
  dinersclub: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
};

export const TEXTO_NENHUMA_RECONHECIDA = 'Nenhuma reconhecida';

function textoBruto(valor) {
  return (Array.isArray(valor) ? valor.join(',') : (valor || '')).trim();
}

export function listarBandeiras(valor) {
  return textoBruto(valor)
    .split(',')
    .map((bandeira) => bandeira.trim().toLowerCase())
    .filter((bandeira) => BANDEIRAS_CARTAO[bandeira])
    .filter((bandeira, indice, lista) => lista.indexOf(bandeira) === indice);
}

export function nomesBandeiras(bandeiras) {
  return bandeiras.map((bandeira) => BANDEIRAS_CARTAO[bandeira] || bandeira).join(', ');
}

export function cobrancaParaEdicao(cobranca) {
  const bandeiras = listarBandeiras(cobranca.bandeiras_cartao);

  return {
    ...cobranca,
    bandeiras_cartao: bandeiras,
    bandeiras_nomes: nomesBandeiras(bandeiras),
    bandeiras_nao_reconhecidas: textoBruto(cobranca.bandeiras_cartao) !== '' && bandeiras.length === 0,
  };
}

export function textoBandeirasDaListagem(row) {
  if (row.cartao != 1) return '-';

  if (row.bandeiras_nao_reconhecidas) return TEXTO_NENHUMA_RECONHECIDA;

  return row.bandeiras_nomes || 'Todas';
}

export function cobrancaParaSalvar(cobranca) {
  return {
    ..._omit(cobranca, ['bandeiras_nomes', 'bandeiras_nao_reconhecidas']),
    bandeiras_cartao: listarBandeiras(cobranca.bandeiras_cartao),
  };
}
